import { CategoryTypeEnum, SavedFileStatus } from 'entities/Files/types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type SearchParams = {
	status: SavedFileStatus;
	sort: 'asc' | 'desc';
	uploadSource: 'FTP' | 'DIRECT' | 'EMAIL' | 'all';
	models: {
		category: CategoryTypeEnum;
		customModelId?: string;
		generativeModelId?: string;
	}[];
	uploaderIdsFilter: string[];
	importFrom?: string;
	importTo?: string;
	autoRemoveFrom?: string;
	autoRemoveTo?: string;
	search: string;
	partnerId?: string;
	page?: string;
	perPage?: string;
};

const initialValues: SearchParams = {
	status: 'RECOGNIZED',
	sort: 'desc',
	uploadSource: 'all',
	models: [],
	uploaderIdsFilter: [],
	search: '',
	page: '1',
};

type SearchParamsStore = {
	initialSearch: SearchParams;
	searchParams: SearchParams;
	changeSearchParams: (params: Partial<SearchParams>) => void;
	resetSearchParams: () => void;
};

export const searchParams = create<SearchParamsStore>()(
	persist(
		(set) => ({
			initialSearch: initialValues,
			searchParams: initialValues,
			changeSearchParams: (params) =>
				set((state) => ({ searchParams: { ...state.searchParams, ...params } })),
			resetSearchParams: () => set({ searchParams: initialValues }),
		}),
		{
			name: 'files-search-params',
		},
	),
);

export const useFilesSearchParams = () => searchParams((state) => state);
